import { render } from "./SelectedNotaryComponent.vue?vue&type=template&id=5b7a6e7e&scoped=true"
import script from "./SelectedNotaryComponent.vue?vue&type=script&lang=js"
export * from "./SelectedNotaryComponent.vue?vue&type=script&lang=js"

import "./SelectedNotaryComponent.vue?vue&type=style&index=0&id=5b7a6e7e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7a6e7e"]])

export default __exports__